// Quotation InternalReview Stage  Btn related codes goes here

// NPM Imports
import React, { Component, Fragment } from "react";

// Components Imports
import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";

// Declarations

class ExportDownloadBtns extends Component {
  state = {};

  render() {
    return (
      <Fragment>
        <ExportDocumentBtn docStatus={this.props.docStatus} />
      </Fragment>
    );
  }
}

export default ExportDownloadBtns;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/ExportDownloadBtns.js